import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { PopupEntryPoint } from '../shared/popup-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './reverseTrialPopup.entrypoint';

export function ReverseTrialPopupDialog(): React.JSX.Element {
	const { product, cloudId } = useEditionAwareness();

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			hamsProductKey: getHamsKey(product),
		}),
		[cloudId, product],
	);

	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			placement={'bottom-end'}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
